import React from 'react';
import {List, ListItemButton} from '@mui/material';
import {designSystemToken, Label} from '@lightricks/react-design-system';
import {DateRange, DefinedPreset} from '../../types';
import {isSameRange} from '../../utils';

type DatePresetsProps = {
  testID: string;
  setRange: (presetRange: DateRange) => void;
  selectedRange: DateRange;
  presets: DefinedPreset[];
};

function DatePresets({
  testID,
  presets,
  setRange,
  selectedRange,
}: DatePresetsProps) {
  return (
    <List data-testid={`${testID}--presets`}>
      {presets.map((preset) => (
        <ListItemButton
          data-testid={`${testID}--preset--${preset.id}`}
          disabled={!!preset.disabled}
          key={preset.id}
          onClick={() => setRange(preset)}
          sx={[
            isSameRange(preset, selectedRange) && {
              'backgroundColor': designSystemToken(
                'semantic.bg.brand-secondary'
              ),
              'color': designSystemToken('semantic.fg.primary'),
              '&:hover': {
                color: designSystemToken('semantic.fg.primary'),
              },
            },
            {
              padding: '16px 24px',
            },
          ]}
        >
          <Label
            size="md"
            style={{
              fontWeight: isSameRange(preset, selectedRange)
                ? 'bold'
                : 'inherit',
            }}
          >
            {preset.label}
          </Label>
        </ListItemButton>
      ))}
    </List>
  );
}

export default DatePresets;
